// Split out of TripDayHotelCard (US-062) to stay under the package's
// max-lines-per-function cap.
export function getTripDayHotelCardPresentation({
  canRemoveHotel,
  isIncludedHotel,
  isGroupLoading,
  hasGroupError,
  isRoomUnavailable,
  readOnly,
  isHotelSelected,
  isMinStayUnmet,
  hotel,
  t,
}: {
  canRemoveHotel: boolean;
  isIncludedHotel: any;
  isGroupLoading: boolean;
  hasGroupError: boolean;
  isRoomUnavailable: any;
  readOnly: boolean;
  isHotelSelected: boolean;
  isMinStayUnmet: boolean;
  hotel: any;
  t: (key: string, options?: Record<string, any>) => string;
}) {
  // The remove, availability and duplicate controls are absolutely positioned
  // over the top-right corner of the card: they overlap the text instead of
  // pushing it, so the column below reserves their width. Without it a long
  // hotel address ran under the duplicate button.
  const hasFloatingControls =
    (canRemoveHotel && !isIncludedHotel) ||
    (!isGroupLoading && (hasGroupError || isRoomUnavailable)) ||
    (!readOnly && isHotelSelected && !isIncludedHotel);

  const showAccessAlert =
    !isGroupLoading && (hasGroupError || isRoomUnavailable);
  const accessAlertTooltip = isMinStayUnmet
    ? t('hotel:minimumStay', { count: Number(hotel?.minimumStay) })
    : isRoomUnavailable
      ? t('compose.someRoomsNotAvailable')
      : t('compose.hotelNotAvailable');

  return { hasFloatingControls, showAccessAlert, accessAlertTooltip };
}
